import { SEOForm } from "@/components/SEOForm";
import Header from "@/components/Header";
import { RecentAnalyses } from "@/components/RecentAnalyses";
import Footer from "@/components/Footer";
const Index = () => {
  return <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <div className="max-w-[960px] mx-auto px-4 py-16">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              A ferramenta de SEO gratuita nº 1 para análise de suas páginas e de concorrentes 📊
            </h1>
            <p className="text-gray-600 text-lg">Com o Page Score é fácil fazer a uma análise competitiva totalmente data-driven. Com ajuda de Inteligência Artificial avalie o SEO On-Page e Off-Page com 20 métricas diferentes, gerando insights para vencer seus concorrentes na busca orgânica!</p>
          </div>
          
          <div className="bg-white rounded-lg p-6">
            <SEOForm />
          </div>
          
          <RecentAnalyses />
        </div>
      </main>
      <Footer />
    </div>;
};
export default Index;